export const LOG_SITE_NAME = 'ScarDispatcherV2';

export const LOG_METRICS = 'UIMetrics';
export const LOG_BUFFER_TIME_SECONDS = 15;
export const LOG_ATTRIBUTE_USER_NAME = 'userName';
export const LOG_ATTRIBUTE_SITE_CODE = 'siteCode';
export const LOG_ATTRIBUTE_SITE_COUNTRY_CODE = 'siteCountryCode';
export const LOG_ATTRIBUTE_USER_AGENT = 'userAgent';
